<div
  class="summary-popup-container"
  (mouseover)="hover = true"
  (mouseleave)="hover = false; data.position !== 'center' ? closePopup() : null"
  (mousemove)="$event.stopPropagation()"
>
  <ng-container *ngIf="summary">
    <div class="summary-popup-header">
      <div class="summary-popup-header-content">
        <u-icon class="icon" [model]="INDICATE_SUMMARY_ICON"></u-icon>
        <div class="title">Summary</div>
      </div>
      <div *ngIf="hover" class="summary-popup-header-action">
        <u-button
          class="space icon"
          [versionNumber]="2"
          typeElement="secondary"
          fontIcon="duplicate"
          (onClick)="copyText()"
          [uTooltip]="tooltipCopyText"
        ></u-button>
        <u-button
          class="open-icon"
          [versionNumber]="2"
          typeElement="secondary"
          fontIcon="launch"
          (onClick)="openResource()"
          uTooltip="Open resource"
          [ngClass]="{ space: data.displayX }"
        ></u-button>
        <u-icon
          *ngIf="data.displayX"
          class="icon"
          (mousedown)="closePopup()"
          [model]="{ type: 'font', value: 'icon-Windows-close' }"
        ></u-icon>
      </div>
    </div>
    <div class="summary">{{ summary }}</div>
  </ng-container>
  <ng-container *ngIf="errorSummary && !summary">
    <div class="summary-popup-error">
      <div class="summary-popup-error-icon">!</div>
      <div class="summary-popup-error-message" [innerHTML]="errorSummary"></div>
    </div>
  </ng-container>
  <ng-container *ngIf="!summary && !errorSummary">
    <result-ghost class="summary-popup-loading" [showAvatar]="false" [ghostingLine]="7"></result-ghost>
  </ng-container>
</div>
